/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedAuctionPreview_item = {
    readonly " $fragmentRefs": FragmentRefs<"PriceDisplay_item" | "useAuctionPricing_item" | "PdpSharedAuctionCountdownLazy_item">;
    readonly " $refType": "PdpSharedAuctionPreview_item";
};
export type PdpSharedAuctionPreview_item$data = PdpSharedAuctionPreview_item;
export type PdpSharedAuctionPreview_item$key = {
    readonly " $data"?: PdpSharedAuctionPreview_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedAuctionPreview_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionPreview_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdownLazy_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '68935cc69a8fcfd7d396e83321a7efee';
export default node;
